exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor[data-v-c1ee1140]{width:100%;margin:0 auto;position:relative;z-index:0}.toolbar[data-v-c1ee1140]{border:1px solid #eeeeee}.text[data-v-c1ee1140]{border:1px solid #eeeeee;min-height:500px}\n", ""]);

// exports
